'use client';
import React from 'react';
import { Phone } from 'lucide-react';
import { hospitalConfig } from '@/data/hospitalConfig';
import { trackEvent } from '@/lib/analytics';

export default function GlobalEmergencyButton() {
  return (
    <a
      href={hospitalConfig?.emergencyTel}
      onClick={() => trackEvent({ event: 'emergency_clicked', source: 'global-emergency-button' })}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-red-700 hover:bg-red-600 text-white rounded-full px-4 py-3 shadow-2xl shadow-red-900/50 transition-all duration-200 hover:scale-105 active:scale-95 group"
      aria-label={`Emergency — Call All Is Well Hospital: ${hospitalConfig?.emergency}`}
      role="button"
    >
      <span className="w-2 h-2 rounded-full bg-red-300 animate-pulse flex-shrink-0" aria-hidden="true" />
      <Phone size={16} className="flex-shrink-0" aria-hidden="true" />
      <span className="text-xs font-bold tracking-widest uppercase hidden sm:block">EMERGENCY</span>
    </a>
  );
}